import React from 'react';
import type { SVGProps } from 'react';

export default function AvgPaceIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M15.25 5q-.525 0-.888-.363T14 3.75t.363-.888t.887-.362t.888.363t.362.887t-.363.888T15.25 5m0 16.5q-.525 0-.888-.363T14 20.25t.363-.888t.887-.362t.888.363t.362.887t-.363.888t-.887.362m4-13q-.525 0-.888-.363T18 7.25t.363-.888T19.25 6t.888.363t.362.887t-.363.888t-.887.362m0 9.5q-.525 0-.888-.363T18 16.75t.363-.888t.887-.362t.888.363t.362.887t-.363.888t-.887.362m1.5-4.75q-.525 0-.888-.363T19.5 12t.363-.888t.887-.362t.888.363T22 12t-.363.888t-.887.362M12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2v2Q8.65 4 6.325 6.325T4 12t2.325 5.675T12 20zm0-8q-.825 0-1.412-.587T10 12q0-.125.013-.262t.062-.263L8 9.4L9.4 8l2.075 2.075q.1-.025.525-.075q.825 0 1.413.588T14 12t-.587 1.413T12 14"
      ></path>
    </svg>
  );
}
